import React, { useEffect, useState, useRef, useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import { mobileBreakpoint } from '../../Utils/Breakpoints';
import { useTranslate } from 'react-translate';

import { WrapLayout } from '../WrapLayout';
import { PositionLayout } from '../PositionLayout';

import { ItemView } from 'cdux_common';
import { Fallback } from 'cdux_common';

import { Logo } from '../Logo';

import './Session.css';

import { DownloadAllButton } from '../Button/DownloadAllButton';
import { downloadInstances } from '../Button/Downloader/Download';
import { ReportStatus } from "../Button/Downloader/Reports/Report";
import { NotificationContext } from '../Notifications/NotificationContext';
import { NotificationBuilder } from '../Notifications/NotificationBuilder';

import successIcon from "../Notifications/Resources/Icons/success.svg";
import failureIcon from "../Notifications/Resources/Icons/info.svg";
import { SessionProvider } from '../../Utils/SessionProvider'
import { checkReadOnly } from '../../Utils/ReadOnlyElements'
import { CTAButton } from '../Button/CTAButton';

export function Session(props) {
    const interactiveBackground = props.projectData.instances.filter((instance) => instance.id === "background")[0]
    const t = useTranslate("session");
    const launchNotification = useContext(NotificationContext).addNotification;

    const nt = useTranslate("notificationTitles");
    const nd = useTranslate("notificationDescriptions");

    const isMobile = useMediaQuery({ query: '(max-width: ' + mobileBreakpoint + 'px)' });

    let wrapInstances = isMobile;
   
    //calcul de la taille de l'�cran pour calculer la position
    let screenHeight = window.innerHeight
    let screenWidth = window.innerWidth

    const [interactiveBackgroundArgs, setInteractiveBackgroundArgs] = useState(null);

    const [playVideo, setPlayVideo] = useState(false);
    const [replayVideo, setReplayVideo] = useState(false);

    const interactiveBgRef = useRef(null);
    
    if (props.projectData && props.projectData.instances && props.projectData.instances.length > 0) {
        let isTransformNeeded = props.projectData.instances.some(instance => instance.transform === undefined || instance.transform === null);
        document.title = props.projectData.name;

        if (isTransformNeeded || props.projectData.sharingFavorites) {
            let ratio = calculateLayout(screenWidth, screenHeight, props.projectData.instances.length)
            calculatePositions(ratio.cols, ratio.rows, props.projectData.instances)
        }        
    }

    let workspace;

    if (!isNaN(parseInt(props.projectData.workspaceSize?.width)) && !isNaN(parseInt(props.projectData.workspaceSize?.height))) {
        workspace = props.projectData.workspaceSize;
    } else {
        workspace = {
            width: 1920,
            height: 1080
        }
    }
        
    function calculateLayout(screenWidth, screenHeight, numElements) {
        const aspectRatio = screenWidth / screenHeight;
        let cols = Math.ceil(Math.sqrt(numElements * aspectRatio));
        let rows = Math.ceil(numElements / cols);
        while (cols * rows < numElements) {
            cols++;
            rows = Math.ceil(numElements / cols);
        }
        return { cols, rows };
    }

    function calculatePositions(cols, rows, instances) {
        const effectiveWidth = 100;
        const effectiveHeight = 100;
        const colWidth = effectiveWidth / cols;
        const rowHeight = effectiveHeight / rows;

        for (let i = 0; i < props.projectData.instances.length; i++) {
            const col = i % cols;
            const row = Math.floor(i / cols);
            const x = col * colWidth / effectiveWidth + 0.5 / cols;
            const y = row * rowHeight / effectiveHeight + 0.5 / rows;
            
            const instance = instances[i];
            if (instance.thumbnailSize) {
                const thumbnailWidth = instance.thumbnailSize.width;
                const thumbnailHeight = instance.thumbnailSize.height;

                const aspectRatio = thumbnailWidth / thumbnailHeight;

                instance.transform = {};
                instance.transform.x = x;
                instance.transform.y = y;

                if (aspectRatio >= 1) {
                    instance.transform.relativeWidthToParent = 0.8 / cols;
                } else {
                    instance.transform.relativeWidthToParent = (0.7 / cols) * (thumbnailWidth / thumbnailHeight);
                }
            }                      
            
        }
    }

    function setInstanceLoaded() {
        if (interactiveBackground && interactiveBackground.itemType === 'video') {
            setPlayVideo(true)
        }
    }

    function handleAnnotation(args) {
        setInteractiveBackgroundArgs(args);  
    }


    const getBackground = () => {

        if (!interactiveBackground) {
            return <img src={props.projectData.backgroundPath} className="sessionBackground" alt="sessionBackground" />          
        }

        if (isMobile) {
            return <div style={{ backgroundColor: props.projectData.theme.darkDarkColor }} className="sessionBackground" />

        } else {
            return <>
                <div className="interactive-bg-container"
                    ref={interactiveBgRef}                  
                >
            <ItemView
                        className="itemView"
                        workspace={workspace}
                        theme={props.projectData.theme}
                        url={interactiveBackground.publicWebUrl}
                        disableIframe={props.projectData.disableIframe}
                        setInstanceLoaded={setInstanceLoaded}
                        handleAnnotation={handleAnnotation}
                        instance={interactiveBackground}
                        playVideo={playVideo}
                        setReplayVideo={setReplayVideo}
                        loop
                        muted
                        Fallback={<Fallback
                            workspace={workspace}
                            theme={props.projectData.theme}
                            thumbnailUrl={interactiveBackground.thumbnailUrl}
                            publicWebUrl={interactiveBackground.publicWebUrl}
                            message={t('unsupported-message')}
                            btnInput={t('download-label')}
                        />}
                        />
                </div>
            </>
        }
    }

    async function downloadFile(instance) {
        try {


            let downloadReport = await downloadInstances([instance]);

            let descKey = null;
            let notification = null;

            /* Retrieve Download status and inform the user */
            switch (downloadReport.status) {
                case ReportStatus.OK:   /* [ Success ] */
                    descKey = downloadReport.data > 1 ? "downloadManyComplete" : "downloadSingleComplete";
                    notification = new NotificationBuilder(successIcon, nt("downloadComplete"), nd(descKey), "notification-success");

                    launchNotification(notification);

                    break;
                case ReportStatus.TIMEOUT:   /* [ Timeout error ] */
                    notification = new NotificationBuilder(failureIcon, nt("downloadTimeoutError"), nd("downloadTimeoutError"), "notification-error");

                    launchNotification(notification);

                    break;
                default:    /* [ Any other error ] */
                    descKey = downloadReport.data > 1 ? "downloadManyError" : "downloadSingleError";
                    notification = new NotificationBuilder(failureIcon, nt("downloadError"), nd(descKey), "notification-error");

                    launchNotification(notification);

                    break;
            }
        } catch (error) {
            console.log(error);

            let notification = new NotificationBuilder(failureIcon, nt("downloadError"), nd("downloadCrashError"), "notification-error");

            launchNotification(notification);
        }


    }

    useEffect(() => {
        document.body.style.overflow = wrapInstances ? 'hidden auto' : 'hidden';
    }, [wrapInstances]);

    useEffect(() => {
        if (!wrapInstances) {
            window.scrollTo(0, 0);
        }
    }, [wrapInstances]);

    return (
        <SessionProvider session={{
            ...(props.projectData || {}),
            workspace: workspace
        }}>
        <div className="session">           
            {props.projectData !== null && props.projectData !== undefined &&
                    <>
                        {getBackground()}                                                                                    
                    <>
                    <div id="titleBox">
                        <div className="souvenir-title">
                                <h1>{props.projectData.name}</h1>
                            <h3>{t('sharedDate').replace('{0}', props.projectData.sharingDate)}</h3>
                        </div>
                    </div>

                        <div className="content" style={wrapInstances ? { pointerEvents: "none" } : { touchAction: 'none', pointerEvents: "none" }}>
                            {
                                wrapInstances ?
                                    <WrapLayout
                                        instances={props.projectData.instances}
                                        linkedInstances={props.projectData.linkedInstances}
                                        workspace={workspace}
                                        downloadFile={downloadFile}
                                />
                                : <PositionLayout
                                        instances={props.projectData.instances}
                                        linkedInstances={props.projectData.linkedInstances}
                                        workspace={workspace}
                                        interactiveBackgroundArgs={interactiveBackgroundArgs}
                                        downloadFile={downloadFile }
                                    />
                        }
                    </div>

                    <div className="logoContainer">
                            <Logo />
                            <CTAButton cta={props.projectData?.cta} />
                    </div>
                      
                            {
                                !checkReadOnly() &&
                                < DownloadAllButton
                                    projectName={props.projectData.name}
                                    instances={props.projectData.instances}
                                    linkedInstances={props.projectData.linkedInstances}
                                />                                
                            }                        
                                       
                </>
                    </>
                }     
            </div>
        </SessionProvider>
    );
}
